import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            // meta: {layout: 'main'},
            meta: {layout: 'main', auth: true, title: 'EURO DENIZ IBU'},
            component: () => import('../views/IndexPage')
        },
        {
            path: '/add-client',
            name: 'add-watch',
            meta: {layout: 'main', auth: true, title: 'EURO DENIZ IBU'},
            component: () => import('../views/Registration')
        },
        {
            path: '/add-account',
            name: 'add-account',
            meta: {layout: 'main', auth: true, title: 'EURO DENIZ IBU'},
            component: () => import('../views/AddAccounts')
        },
        {
            path: '/payment-request',
            name: 'payment-request',
            meta: {layout: 'main', auth: true, title: 'EURO DENIZ IBU'},
            component: () => import('../components/paymentRequest')
        },
        {
            path: '/shops-payments',
            name: 'shops-payments',
            meta: {layout: 'main', auth: true, title: 'EURO DENIZ IBU'},
            component: () => import('../components/ShopsPayments')
        },
        {
            path: '/intra-transfers',
            name: 'intra-transfers',
            meta: {layout: 'main', auth: true, title: 'EURO DENIZ IBU'},
            component: () => import('../components/intraTransfer')
        },
        {
            path: '/accounts-list',
            name: 'accounts-list',
            meta: {layout: 'main', auth: true, title: 'EURO DENIZ IBU'},
            component: () => import('../components/accounts')
        },
        {
            path: '/login',
            name: 'about',
            meta: {layout: 'empty', title: 'EURO DENIZ IBU'},
            component: () => import('../views/Login.vue')
        }
    ]
});

router.beforeEach((to, from, next) => {
    const token = localStorage.getItem("t");
    const requireAuth = to.matched.some(record => record.meta.auth);
    if (requireAuth && !token) {
        next("/login");
    } else {
        next();
    }
});

export default router
